import { render, staticRenderFns } from "./InvestorsTab.vue?vue&type=template&id=2d45d8b1&scoped=true"
import script from "./InvestorsTab.vue?vue&type=script&lang=js"
export * from "./InvestorsTab.vue?vue&type=script&lang=js"
import style0 from "./InvestorsTab.vue?vue&type=style&index=0&id=2d45d8b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d45d8b1",
  null
  
)

export default component.exports